import React from "react";
import { Helmet } from "react-helmet-async";

const BASE = "https://bursluluksinavi.com";

export default function SEO({ title, description, canonical, image, jsonLd, keywords, type = "website" }) {
  const fullTitle = title ? `${title} | SanoStudent` : "SanoStudent — Bursluluk Sınavı, Deneme Sınavı ve Tercih Platformu";
  const desc = description || "Türkiye'nin özel okul bursluluk sınavı, deneme sınavı, LGS/TYT/AYT çıkmış sorular ve AI destekli tercih danışmanlığı platformu.";
  const url = canonical ? `${BASE}${canonical}` : BASE;
  const img = image || "https://images.pexels.com/photos/7092523/pexels-photo-7092523.jpeg";
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={type} />
      <meta property="og:image" content={img} />
      <meta property="og:locale" content="tr_TR" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}
